import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GridModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { SharedModule } from '../../shared/shared.module';
import { AssetTypeRoutingModule } from './asset-type-routing.module';
import { AssetTypeAddDialogComponent } from './components/asset-type-add-dialog/asset-type-add-dialog.component';
import { AssetTypeListComponent } from './components/asset-type-list/asset-type-list.component';
import { AssetTypeService } from './service/asset-type.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    AssetTypeRoutingModule,
    GridModule,
    InputsModule
  ],
  declarations: [AssetTypeListComponent, AssetTypeAddDialogComponent],
  exports: [],
  providers: [AssetTypeService],
  entryComponents: [AssetTypeAddDialogComponent]
})
export class AssetTypeModule {}
